import { Row } from "antd";
import styled from "styled-components";

export const ExtensionLoginPageStyled = styled(Row)`
  &.wrapper-content {
    .content-container {
      .sign-up-container {
        .sign-up-btn {
          font-size: 16px;
        }
      }
    }
  }

  > div {
    justify-content: center;
  }

  .a-section {
    display: flex;
  }

  .content-container {
    margin: 45px 0px 12px 0px;
    text-align: center;
    font-size: 15px;
    max-width: 58.5%;
    display: flex;
    flex-direction: column;
    align-items: center;

    .header {
      margin-bottom: 51px;
      font-size: 24px;
      font-family: OpenSansBold;
    }

    .icon-container {
      margin-bottom: 33px;
    }

    .description {
      margin-bottom: 28px;
    }

    .login-btn-container {
      display: flex;
      justify-content: center;
      margin-bottom: 46px;

      button {
        background: ${({ theme }): string => theme.bgColors.ORANGE_6};
        color: ${({ theme }): string => theme.textColors.WHITE_COLOR};
        border: none;
        border-radius: 27px;
        height: 52px;
        width: 111px;
        font-size: 16px;
        font-family: OpenSansBold;
      }
    }

    .or-text {
      margin-bottom: 32px;
      font-family: OpenSansSemiBold;
    }
  }
`;
